import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=b02657a0&scoped=true&"
import script from "./Settings.vue?vue&type=script&lang=js&"
export * from "./Settings.vue?vue&type=script&lang=js&"
import style0 from "@/css/componentDropdown.css?vue&type=style&index=0&id=b02657a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b02657a0",
  null
  
)

export default component.exports